import { connect } from 'react-redux';
import { getUserRegistrationFormPage } from '../selectors';
import { updateUserRegistrationForm } from '../actions';
import UserRegistrationForm from '../components/UserRegistrationForm';

const mapStateToProps = state => getUserRegistrationFormPage(state);

const mapDispatchToProps = dispatch => {
    return {
        onFieldsUpdated: fields => {
            dispatch(updateUserRegistrationForm(fields));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(UserRegistrationForm);
